import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import api from '../../../services/api';

interface Props {
  personaId: string;
}

const Portfolio: React.FC<Props> = ({ personaId }) => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  const [artifacts, setArtifacts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/cross-system/persona/${personaId}/portfolio`)
      .then(r => setArtifacts(r.data?.artifacts || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [personaId]);

  if (loading) return <div className={`text-sm ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>Loading portfolio...</div>;

  if (artifacts.length === 0) {
    return (
      <div className={`p-8 text-center rounded-lg border ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-200 text-gray-400'}`}>
        No artifacts generated yet. This persona's portfolio will grow as it hydrates artifactory nodes.
      </div>
    );
  }

  return (
    <div>
      <div className={`text-sm mb-4 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        {artifacts.length} artifact{artifacts.length !== 1 ? 's' : ''} generated
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {artifacts.map((a, i) => (
          <div
            key={a.id || i}
            className={`p-4 rounded-lg border cursor-pointer transition-all hover:scale-[1.01] ${
              darkMode
                ? 'bg-gray-800/60 border-gray-700 hover:border-purple-600/50'
                : 'bg-white border-gray-200 hover:border-purple-400'
            }`}
          >
            <p className={`text-sm font-medium truncate ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
              {a.metadata?.node_path || a.source_id?.slice(0, 8) || 'Artifact'}
            </p>
            <p className={`text-xs mt-1 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
              {new Date(a.created_at).toLocaleDateString()}
              {a.metadata?.persona_revision != null && ` · rev ${a.metadata.persona_revision}`}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
